import React, { useEffect, useState } from 'react';
import './CheckoutProduct.css';
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';

function CheckoutProduct({id, title, price, img, qnt}) {
    const [{ basket }, dispatch] = useStateValue();
    var qqnt = qnt;

    const removeFromBasket = () => {
        //remove the item from the basket
        dispatch({
            type: 'REMOVE_FROM_BASKET',
            id: id,
        })
    }

    const add = () =>{
        qnt += 1;
        dispatch({
            type: "ADD_TO_Qnt",
            id: id,
            title: title,
            price: price,
            img: img,
            qnt: qnt
        });
    }

    const sub = () =>{
        qnt -= 1;
        
        dispatch({
            type: "SUB_TO_Qnt",
            id: id,
            title: title,
            price: price,
            img: img,
            qnt: qnt
        });       
    }

    useEffect(() => {

        if(qnt > 1){
            document.getElementById(id).disabled = false;
        }
        else{
            document.getElementById(id).disabled = true;
        }
      
    }, [qnt])
    

    return (
        <div className="checkoutproduct">
            <div className="checkoutproduct__left"><img className="checkoutproduct__img" src={img} alt="cart"/></div>
            <div className="checkoutproduct__right">
                <div className="checkoutproduct__up">
                    <h4>{title}</h4>
                    <div className="checkoutproduct__btn">
                        <button onClick={removeFromBasket}>
                            <span class="iconify" data-icon="line-md:remove" data-width="15" data-height="15"></span>
                        </button>
                    </div>
                </div>
                <div className="checkoutproduct__down">
                    <div className='checkoutproduct__price'>
                        <strong>Price</strong>
                        <CurrencyFormat
                            renderText={(value) => (
                                <>
                                    <small>{value}</small>
                                </>
                            )}
                            decimalScale={2}
                            value={price}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                        />
                    </div>
                    <div className='checkoutproduct__qnt'>
                        <strong>Quantity</strong>
                        <div>
                            <button id={id} onClick={sub}>-</button>
                                <label>{qnt}</label>
                            <button onClick={add}>+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )}

export default CheckoutProduct;
